import "./assets/css/tailwind.css";
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-table/react-table.css";

import { isMultiColorActive, defaultColor,themeColorStorageKey,isDarkSwitchActive } from "./constants/defaultValues";
const color =
  (isMultiColorActive||isDarkSwitchActive ) && localStorage.getItem(themeColorStorageKey)
    ? localStorage.getItem(themeColorStorageKey)
    : defaultColor;

localStorage.setItem(themeColorStorageKey, color);

let render = () => {
  // First load the theme SCSS (which includes _gogo.style.scss)
  import('./assets/css/sass/themes/gogo.' + color + '.scss').then(() => {
    // Then load all enhanced CSS files AFTER the theme to ensure they override base styles
    Promise.all([
      import('./assets/css/global-enhancements.css'),
      import('./assets/css/enhanced-table.css'),
      import('./assets/css/enhanced-heading.css'),
      import('./assets/css/table-animations.css'),
      import('./assets/css/sidebar-modern.css'),
      import('./assets/css/topnav-modern.css')
    ]).then(() => {
      // Finally render the app after all styles are loaded
      require('./AppRenderer');
    });
  });
};
render();